// Black (#444444) = good signal, Gray (#ADADAD) = bad signal (numbers only).
// Backend sends signal_quality as boolean true/false (good/bad).
// Color only flips to gray after 3 consecutive bad readings, and flips back to black
// as soon as a single good reading comes in.
// Placeholder "--" always stays #444444 at the previous text size (tdNumber).
const isValidSpo2 = (spo2) => {
    if (spo2 === undefined || spo2 === null || spo2 === '' || spo2 === '--') {
        return false;
    }
    const n = Number(spo2);
    return !Number.isNaN(n) && n > 0;
};

const isGoodSignal = (signalQuality) => {
    if (signalQuality === true || signalQuality === 1 || signalQuality === '1') {
        return true;
    }
    if (signalQuality === false || signalQuality === 0 || signalQuality === '0') {
        return false;
    }
    // Legacy string values from older payloads
    if (signalQuality === 'Good') {
        return true;
    }
    if (signalQuality === 'bad' || signalQuality === 'Bad') {
        return false;
    }
    return false;
};

const isBadReading = (reading) => {
    if (!reading) return true;
    if (!isValidSpo2(reading.spo2)) {
        return true;
    }
    return !isGoodSignal(reading.signal_quality);
};

// Display rules (unchanged):
// - spo2 + good signal → show number (ok)
// - bad/missing signal + spo2 > 80 → show number (bad / unreliable)
// - otherwise (no spo2, or spo2 ≤ 80 with bad signal) → '--'
export const getSpo2Value = (fData, item) => {
    const readings = fData?.[String(item?.user_id)];

    if (!readings?.length) {
        return { value: '--', type: 'bad' };
    }

    const lastElement = readings[readings.length - 1];
    const spo2 = lastElement?.spo2;
    const hasSpo2 = spo2 !== undefined && spo2 !== null && spo2 !== '' && spo2 !== '--' && Number(spo2) > 0;

    // Good signal (boolean true, or legacy "Good") → show value
    if (hasSpo2 && isGoodSignal(lastElement?.signal_quality)) {
        return { value: spo2, type: 'ok' };
    }

    // Bad/missing signal but spo2 > 80 → still show the number
    if (!isGoodSignal(lastElement?.signal_quality) && hasSpo2 && Number(spo2) > 80) {
        return { value: spo2, type: 'bad' };
    }

    // No spo2, or spo2 ≤ 80 with bad signal → hide
    return { value: '--', type: 'bad' };
};

export const loadColorCode = (fData, item) => {
    // Placeholder "--" always keeps the previous default color (not signal-quality gray).
    if (getSpo2Value(fData, item).value === '--') {
        return { color: '#444444' };
    }

    const readings = fData?.[String(item?.user_id)] || [];
    let consecutiveBad = 0;

    for (let i = readings.length - 1; i >= 0; i -= 1) {
        if (isBadReading(readings[i])) {
            consecutiveBad += 1;
            if (consecutiveBad >= 3) {
                return { color: '#ADADAD' };
            }
        } else {
            break;
        }
    }

    return { color: '#444444' };
};
